import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { useCatalog } from "../../contexts/CatalogContext";

export default function FaqSection() {
  const { FAQS } = useCatalog();

  return (
    <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-testid="faq-section">
      <div className="text-center mb-10">
        <span className="text-xs font-semibold text-[#FF6B2B] uppercase tracking-widest">FAQ</span>
        <h2 className="font-display font-bold text-3xl sm:text-4xl text-slate-900 mt-2">Got questions?</h2>
      </div>
      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`item-${i}`}
            data-testid={`faq-item-${i}`}
            className="bg-white rounded-xl border border-slate-200 px-5"
          >
            <AccordionTrigger className="text-left font-semibold text-slate-900 hover:no-underline py-4">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-slate-600 leading-relaxed pb-4">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
